// extracted by mini-css-extract-plugin
export default {"customersSelectHint":"customers-select_customersSelectHint__s4RSS"};